import { Component, EventEmitter, Input, Output } from '@angular/core';

type ReportSortField =
  | 'Topic_Sort_Order'
  | 'Number_Of_Questions'
  | 'Number_of_Practice_Questions'
  | 'Percentage_of_Practice_Questions';

@Component({
  selector: 'app-study-unit-practice-question-report-table',
  templateUrl: './study-unit-practice-question-report-table.component.html',
  styleUrls: ['./study-unit-practice-question-report-table.component.css'],
})
export class StudyUnitPracticeQuestionReportTableComponent {
  @Input() rows: any[] = [];
  @Output() assignPracticeQuestion = new EventEmitter<any>();
  @Output() editStudyUnit = new EventEmitter<any>();
  @Output() editStudyMaterial = new EventEmitter<any>();

  reportSortField: ReportSortField = 'Topic_Sort_Order';
  reportSortDirection: 'asc' | 'desc' = 'asc';

  get sortedRows(): any[] {
    const sourceRows = [...(this.rows || [])];
    const sortBy = this.reportSortField;
    const direction = this.reportSortDirection === 'asc' ? 1 : -1;

    return sourceRows.sort((a: any, b: any) => {
      const aVal = this.getSortableNumberValue(a?.[sortBy]);
      const bVal = this.getSortableNumberValue(b?.[sortBy]);
      return (aVal - bVal) * direction;
    });
  }

  sortBy(field: ReportSortField) {
    if (this.reportSortField === field) {
      this.reportSortDirection =
        this.reportSortDirection === 'asc' ? 'desc' : 'asc';
      return;
    }

    this.reportSortField = field;
    this.reportSortDirection = 'desc';
  }

  isTestNotesFile(fileName: string): boolean {
    return String(fileName || '').trim().toLowerCase() === 'test notes.pdf';
  }

  getSortIconClass(field: ReportSortField): string {
    if (this.reportSortField !== field) {
      return 'fa-sort';
    }

    return this.reportSortDirection === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  isSortFieldActive(field: ReportSortField): boolean {
    return this.reportSortField === field;
  }

  private getSortableNumberValue(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : 0;
    }

    const normalized = String(value).replace(/[^0-9.-]/g, '');
    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  onAssignPracticeQuestion(row: any) {
    this.assignPracticeQuestion.emit(row);
  }

  onEditStudyUnit(row: any) {
    this.editStudyUnit.emit(row);
  }

  onEditStudyMaterial(row: any) {
    this.editStudyMaterial.emit(row);
  }
}
